export const ZAPPOS_MERCHANTID = 'AMWRKCC3EWKYM';
export const SIXPM_MERCHANTID = 'A1DAQHZV8E3DTX';

export const merchantIdHostMapping: Partial<Record<string, string>> = {
  [ZAPPOS_MERCHANTID]: 'zappos',
  [SIXPM_MERCHANTID]: '6pm'
};
